import { useEffect, useRef, useState } from 'react';
import { FieldProps, wdiCore, WdiModalAppProps } from '@/components/WdiControls';
import { ProFormInstance } from '@ant-design/pro-form';
import { EC } from '@/services/mdm/ec';
import { WdiSelect, WdiSelectFormat, WdiTreeSelect } from '@/components/WdiControls/WdiSelect';
import { Form, message } from 'antd';
import { HorzLayoutOpts, WdiModalForm } from '@/components/WdiControls/WdiModalForm';
import { responseIsSuccess, ResponseStatus } from '@/utils/request';
import { SoldTo } from '@/services/mdm/soldto';
import { Enum } from '@/enums/system';
import { FormSa } from '@/services/sales/sa';


const FormSaDetailPrevApp: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [ecTreeData, setEcTreeData] = useState<any[]>();
  const [ecDict, setEcDict] = useState<any[]>();
  const { row, rowIndex, formSa } = props.data;

  const handleSoldToChange = (soldToCode: any) => {
    formRef.current?.setFieldsValue({ boId: null });
    EC.searchEc3({
      toParentLevel: Enum.ECLevel.EC2,
      bohqId: formSa.bohqId,
      pageTypeIds: String(formSa.pageTypeId),
      soldToCode: soldToCode,
      isActive: true
    }).then(response => {
      if (responseIsSuccess(response)) {
        const { treeData, dict } = FieldProps.TreeSelect.formatTreeData({
          textField: "ecName",
          valueField: "ecId",
          id: "ecId",
          pId: "parentId",
          level: "ecLevel",
          disabledLevel: [Enum.ECLevel.EC2],
        }, response.data);
        setEcTreeData(treeData);
        // @ts-ignore
        setEcDict(dict);
      }
    });
  };

  useEffect(() => {
    if (row) {
      if (row.ecId) {
        handleSoldToChange(row.soldToCode);
        formRef.current?.setFieldsValue({ ecId: row.ecId });
        // formRef.current?.setFieldsValue({ ecId: { ecId: row.ecId, label: wdiCore.String.Join(row.ecId, row.ecName) } });
      }

      if (row.soldToCode) {
        formRef.current?.setFieldsValue({
          soldToCode: { value: row.soldToCode, label: wdiCore.String.Join(row.soldToCode, row.soldToName) }
        });
      }
    }
  }, [row]);

  return (
    <WdiModalForm
      formRef={formRef}
      title={props.title}
      visible={props.visible}
      modalProps={{
        onCancel: () => {
          props.onClose?.()
        },
      }}
      submitter={{ searchConfig: { submitText: '下一步', }, }}
      onFinish={async (values) => {
        const { ecId, soldToCode, ...entity } = values;

        entity.ecId = WdiSelectFormat.getvalue(ecId);
        entity.soldToCode = WdiSelectFormat.getvalue(soldToCode);
      
        const response = await FormSa.Buttons.validatePicker({
          rowIndex: rowIndex,
          formSaDetail: entity,
          formSa: { ...formSa },
        });
        if (!responseIsSuccess(response)) {
          message.error(response.message);
        } else if (props.onSave) {
          const formSaDetail = Object.assign({}, row, {
            ecId: response.data.ecId,
            ecName: response.data.ecName,
            soldToCode: response.data.soldToCode,
            soldToName: response.data.soldToName
          });

          // formSaDetail.revenueType = response.data.revenueType;
          // formSaDetail.revenueTypeName = response.data.revenueTypeName;

          props.onSave({
            code: ResponseStatus.SUCCESS,
            data: Object.assign({}, { formSaDetail: formSaDetail }, props.data),
          });
        }
      }}
      {...HorzLayoutOpts}
    >

      <Form.Item name="soldToCode" label="售达方" rules={[{ required: true, message: '售达方不能为空!' }]}>
        <WdiSelect {...{
          placeholder: "请选择售达方",
          showSearch: true,
          remote: true,
          dataLoading: async (params) => {
            const response = await SoldTo.ajaxSearch(Object.assign({
              // withPermissions: true,
              withBoHqPermissions: true,
              isActive: true,
              bohqId: formSa.bohqId
            }, params));
            return response.data.map((item) => {
              return { value: item.soldToCode, label: item.codeOrName };
            });
          },
          onChange: handleSoldToChange
        }} />
      </Form.Item>
      <Form.Item name="ecId" label="费用项" rules={[{ required: true, message: '费用项不能为空!' }]}>
        <WdiTreeSelect {...{
          placeholder: "请选择费用项",
          treeData: ecTreeData,
          dict: ecDict
        }} />
      </Form.Item>
    </WdiModalForm>
  );
};
export default FormSaDetailPrevApp;
